// Import what we need from Obscenity.
import { DataSet, englishDataset, pattern } from 'obscenity';

// Create a new dataset.
export const myDataset = new DataSet()
    // Add all the data from the english dataset into our new one.
    .addAll(englishDataset)
    // Remove "fuck" and all its variants.
    //.removePhrasesIf((phrase) => phrase.metadata.originalWord === 'fuck')
    // Add Dutch phrases.
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'godverdomme' })
            .addPattern(pattern`godverdomme`)
            .addPattern(pattern`godverdome`)
            .addPattern(pattern`gvd`)
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'verdomme' })
            .addPattern(pattern`verdomme`)
            .addPattern(pattern`verdom[m]e`)
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'kut' })
            .addPattern(pattern`kut`)
            .addPattern(pattern`k*t`)
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'hoer' })
            .addPattern(pattern`hoer`)
            .addWhitelistedTerm('hoera')
            .addWhitelistedTerm('geouwehoer')
    )
    .addPhrase((phrase) =>
        phrase.setMetadata({ originalWord: 'neuken' }).addPattern(pattern`neuk`)
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'neger' })
            .addPattern(pattern`neger`)
            .addWhitelistedTerm('negeren')
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'flikker' })
            .addPattern(pattern`flikker`)
            .addPattern(pattern`fliker`)
            .addWhitelistedTerm('flikkeren')
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'pokkenwijf' })
            .addPattern(pattern`pokkenwijf`)
            .addPattern(pattern`pokenwijf`)
    )
    .addPhrase((phrase) =>
        phrase
            .setMetadata({ originalWord: 'lul' })
            .addPattern(pattern`lul`)
            .addWhitelistedTerm(`lullig`)
    )
    .addPhrase((phrase) => phrase.addPattern(pattern`klootzak`))
    .addPhrase((phrase) => phrase.addPattern(pattern`slet`))
    .addPhrase((phrase) => phrase.addPattern(pattern`mongool`))
    .addPhrase((phrase) => phrase.addPattern(pattern`tyfus`))
    .addPhrase((phrase) => phrase.addPattern(pattern`klote`))
    .addPhrase((phrase) => phrase.addPattern(pattern`tering`))
    .addPhrase((phrase) => phrase.addPattern(pattern`lijer`))
    .addPhrase((phrase) => phrase.addPattern(pattern`roetmop`))
    .addPhrase((phrase) => phrase.addPattern(pattern`trut`))
    .addPhrase((phrase) => phrase.addPattern(pattern`debiel`));
